import $ from 'jquery'
import Toastr from 'toastr2'

/**
 * select2
 */
$('.js-select2-on').select2();

const toastrOptions = {
    'closeButton': true,
    'debug': false,
    'newestOnTop': true,
    'progressBar': true,
    'positionClass': 'toast-bottom-right',
    'preventDuplicates': true,
    'showDuration': '300',
    'hideDuration': '1000',
    'timeOut': '3000',
    'extendedTimeOut': '1000',
    'showEasing': 'swing',
    'hideEasing': 'linear',
    'showMethod': 'fadeIn',
    'hideMethod': 'fadeOut'
}

const toastr = new Toastr(toastrOptions)

/**
 * Created by Batyukov on 08.05.17.
 */

initAjax()

// Set up the Select2 control




function initAjax() {

    $('.js-onchange-ajax').on('submit', function () {
        return false;
    });

    $('.js-onchange-ajax').off('change').on('change', function () {


        const formData = $(this).serialize()
        const method = $(this).attr('method')
        const action = $(this).attr('action')
        const target = $(this).data('target')
        const command = $(this).data('command')
        const attributes = $(this).data()

        $.ajax({
            type: method,
            url: action,
            data: formData,
            async: true,
            success: function (data) {
                if (data.data && target && command) {
                    switch (command) {
                        case 'before': {
                            $('[' + target + ']').before(data.data)
                        }
                            break
                        case 'after': {
                            $('[' + target + ']').after(data.data)
                        }
                            break
                        case 'replace': {
                            // console.log('replace');
                            $('[' + target + ']').after(data.data).remove()
                        }
                            break
                    }
                    initAjax()
                }

                if (command && command === 'remove') {
                    $('[' + target + ']').remove()
                }

                if (data.flashMessages) {
                    data.flashMessages.forEach(function (item, i, arr) {
                        if (item.type && item.text) {
                            toastr[item.type](item.text)
                        }
                    })
                }

                if (method === 'GET') {
                    history.pushState(formData, document.title, window.location.pathname + '?' + formData)
                    initAjax()
                }

            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR && jqXHR.hasOwnProperty('responseJSON')) {
                    let response = jsXHR.responseJSON
                    if (response.hasOwnProperty('message')) {
                        console.log(response.message);
                    }
                } else {
                    console.log(textStatus, errorThrown)
                }
            }
        })
        return false
    })

}


$('.js-select-ajax').each(function () {
    let select = $(this);
    select.select2({
            placeholder: 'Выберите опцию',
            language: "ru",
            theme: 'bootstrap4',
            minimumInputLength: 3,
            allowClear: false,
            ajax: {
                dataType: 'json',
                data: function (params) {
                    return {
                        q: $.trim(params.term),
                        term: params.term || '',
                        page: params.page || 1,
                        perPage: params.perPage || 25,
                    }
                },
                processResults: function (response, params) {
                    params.page = params.page || 1;
                    return {
                        results: response.data,
                        pagination: {
                            more: response.last_page !== params.page
                        }
                    };
                }
            }
        }
    );
});
